import ObexRequestsHandlerP80 from '../handlers/ObexRequestsHandlerP80';
import { BillingLine, BillingLinePayload } from '../types/Store.types';
import { getAccessToken, getActiveCompanyId, buildQuery, unwrapList, unwrapRecord, unwrapRecordOrObject, unwrapError, getTransportError } from './apiUtils';

const ROUTES = {
  list:   '/billing_lines_list',
  create: '/billing_lines_create',
  update: '/billing_lines_update',
  remove: '/billing_lines_delete'
};

export const mapBillingLine = (raw: any): BillingLine => ({
  id:          String(raw.id),
  companyId:   raw.company_id !== undefined && raw.company_id !== null ? String(raw.company_id) : '',
  code:        raw.code || '',
  name:        raw.name || '',
  series:      raw.series || '',
  invoiceSeries: raw.invoice_series || '',
  status:      raw.status === 'inactive' ? 'inactive' : 'active',
  storesCount: Number(raw.stores_count) || 0
});

export const listBillingLines = async (options: { companyId?: string; status?: string } = {}): Promise<BillingLine[]> => {
  const token = getAccessToken();
  if (!token) throw new Error('Sesión no válida o expirada.');
  const res = await ObexRequestsHandlerP80.get(`${ROUTES.list}${buildQuery({
    access_token: token,
    company_id:   options.companyId || getActiveCompanyId(),
    status:       options.status
  })}`);
  const transport = getTransportError(res);
  if (transport) throw new Error(transport);
  return unwrapList(res).map(mapBillingLine);
};

export const createBillingLine = async (payload: BillingLinePayload): Promise<BillingLine> => {
  const token = getAccessToken();
  if (!token) throw new Error('Sesión no válida o expirada.');
  const res = await ObexRequestsHandlerP80.get(`${ROUTES.create}${buildQuery({
    access_token: token,
    company_id:   payload.companyId || getActiveCompanyId(),
    code:         payload.code,
    name:         payload.name,
    series:       payload.series,
    invoice_series: payload.invoiceSeries,
    status:       payload.status
  })}`);
  const record = unwrapRecord(res);
  if (!record) throw new Error(unwrapError(res, 'Error al crear la línea de facturación.'));
  return mapBillingLine(record);
};

export const updateBillingLine = async (id: string, payload: BillingLinePayload): Promise<BillingLine> => {
  const token = getAccessToken();
  if (!token) throw new Error('Sesión no válida o expirada.');
  const res = await ObexRequestsHandlerP80.get(`${ROUTES.update}${buildQuery({
    access_token: token,
    id,
    name:         payload.name,
    series:       payload.series,
    invoice_series: payload.invoiceSeries,
    status:       payload.status
  })}`);
  const record = unwrapRecord(res);
  if (!record) throw new Error(unwrapError(res, 'Error al modificar la línea de facturación.'));
  return mapBillingLine(record);
};

export const deleteBillingLine = async (id: string): Promise<void> => {
  const token = getAccessToken();
  if (!token) throw new Error('Sesión no válida o expirada.');
  const res = await ObexRequestsHandlerP80.get(`${ROUTES.remove}${buildQuery({ access_token: token, id })}`);
  // El endpoint responde {message}; un error llega como string plano
  const out = unwrapRecordOrObject(res);
  if (!out || !out.message) throw new Error(unwrapError(res, 'Error al eliminar la línea de facturación.'));
};
